
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPurposeReasonGrid extends Serenity.EntityGrid<PsPurposeReasonRow, any> {
        protected getColumnsKey() { return PsPurposeReasonColumns.columnsKey; }
        protected getDialogType() { return PsPurposeReasonDialog; }
        protected getIdProperty() { return PsPurposeReasonRow.idProperty; }
        protected getInsertPermission() { return PsPurposeReasonRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPurposeReasonRow.localTextPrefix; }
        protected getService() { return PsPurposeReasonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}